// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.user.LoginSessionInfo
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class LoginSessionInfo {
  static createLoginSessionInfo(location, loginTime, logoutTime) {
    const retVal = new LoginSessionInfo();
    retVal.initLoginSessionInfo(location, loginTime, logoutTime);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createLoginSessionInfo factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadu.LoginSessionInfo";
  }
  initFromJson(json, deserializeContext) {
    this.initLoginSessionInfo(json.location != null ? json.location : null, json.loginTime != null ? new Date(json.loginTime) : null, json.logoutTime != null ? new Date(json.logoutTime) : null);
  }
  initLoginSessionInfo(location, loginTime, logoutTime) {
    this._location = location;
    this._loginTime = loginTime;
    this._logoutTime = logoutTime;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["location"] = this._location;
    retVal["loginTime"] = this._loginTime;
    retVal["logoutTime"] = this._logoutTime;
    return retVal;
  }
  get location() {
    return this._location;
  }
  set location(value) {
    this._location = value;
  }
  get loginTime() {
    return this._loginTime;
  }
  set loginTime(value) {
    this._loginTime = value;
  }
  get logoutTime() {
    return this._logoutTime;
  }
  set logoutTime(value) {
    this._logoutTime = value;
  }
}
//# sourceMappingURL=LoginSessionInfo.js.map
